/** Customer-facing copy when card payment is available but no HitPay link is on the invoice. */
export function formatCardPaymentUnavailableMessage(salespersonName?: string | null): string {
  const name = String(salespersonName ?? "").trim() || "YOUR SALES REPRESENTATIVE";
  return `CREDIT CARD PAYMENT IS AVAILABLE. ADDITIONAL ADMINISTRATIVE CHARGES MAY APPLY. CONTACT YOUR ${name.toUpperCase()}.`;
}

export function cardSurchargeDisclaimerText(
  cardAdminFeeApplied: boolean,
  totalPayable: number,
  cleanTotalWithoutCardFee: number
): string | null {
  if (!cardAdminFeeApplied) return null;
  return `A 3.5% administrative charge applies for card payments. Amount payable by card: SGD ${totalPayable.toFixed(2)}. To avoid this charge, pay via PayNow, bank transfer, or cash. Invoice total (excl. card fee): SGD ${cleanTotalWithoutCardFee.toFixed(2)}.`;
}
